import * as React from 'react';
import { Sounds } from 'source/app/services/Sound/Sounds';
import Player from '../../../../domain/Player';
import MotwLogicServer from '../../../../services/External/LogicServer/MotwLogicServer';
import { GetGameMode } from '../../../../services/Game/GameMode/GameMode';
import { BannerImages } from '../../../../services/Shared/RenderSwal/BannerImage/BannerImage';
import RenderSwal from '../../../../services/Shared/RenderSwal/RenderSwal';
import Render from '../../../Shared/Render';
import MountainGraph from './MountainGraph/MountainGraph';
const styles = require('./PlayerDetails.css');

const ShowPlayerDetails = async () => {
	RenderSwal(
		{ bannerImage: BannerImages.flagTrumpet },
		<PlayerDetails />,
		() => {}
	);
};

export default ShowPlayerDetails;

interface IPlayerDetailsState {
	daysInGame: number;
	level: number;
	lifetimeKipsEarned: number;
}

class PlayerDetails extends React.Component<{}, IPlayerDetailsState> {
	constructor(props: {}) {
		super(props);
		this.state = {
			daysInGame: 0,
			level: 0,
			lifetimeKipsEarned: 0
		};
	}
	
	componentWillMount() {
		Sounds.curiousTrumpet.Play();
	}

	async componentDidMount() {
		this.setState({
			daysInGame: await MotwLogicServer.GetPlayerDaysInGame(),
			level: await MotwLogicServer.GetPlayerLevelCurrent(),
			lifetimeKipsEarned: await MotwLogicServer.GetPlayerLifetimeKipsEarned()
		});
	}

	render() {
		const moreDetails = [
			{
				label: 'Playing for',
				text: `${this.state.daysInGame} days`
			},
			{
				label: 'Earned',
				text: `${this.state.lifetimeKipsEarned}₭`
			},
			{
				label: 'Mode',
				text: GetGameMode(this.state.level).name
			}
		];

		return (
			<div>
				<Render id="playerDetailsLoading" when={!this.state.level}>
					Loading...
				</Render>
				<Render id="playerDetails" when={this.state.level}>
					<div>
						<div className={styles.name}>{Player.userName}</div>
						<div className={styles.moreDetails}>
							{moreDetails.map((detail, index) => (
								<div key={index}>
									<span className={styles.label}>
										{detail.label}
									</span>
									<strong>{detail.text}</strong>
								</div>
							))}
						</div>
					</div>
					<MountainGraph currentLevel={this.state.level} />
				</Render>
			</div>
		);
	}
}
